export default class BasketRecipient {
    constructor(email, user_id) {
        this.email = email || '';
        this.user_id = user_id || '';
    }
}